import { VxeUI } from 'vxe-pc-ui';

export const closeAll = () => {
    return VxeUI.modal.close();
};

export const confirm = (title, msg, options = {
    id: '',
    cancelText: '取消',
    confirmText: '确定',
}) => {
    return new Promise((resolve) => {
        const { id, cancelText, confirmText } = options;
        VxeUI.modal.confirm({
            id,
            cancelButtonText: cancelText,
            confirmButtonText: confirmText,
            title,
            content: msg,
            mask: true,
            showClose: true,
            maskClosable: true,
            showConfirmButton: true,
            escClosable: true,
        }).then((type) => {
            if (type === 'confirm') {
                resolve(true);
            } else {
                resolve(false);
            }
        });
    });
};
